export default {"src":"/_next/static/media/hot-zone-report.98c02796.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};